// USGS earthquake feed (GeoJSON, CORS open): every magnitude 4.5+ event of the last day.

import type { Fetcher } from '../types.ts';
import { getJson } from './http.ts';
import type { LiveRecord } from './types.ts';

const URL_4_5_DAY = 'https://earthquake.usgs.gov/earthquakes/feed/v1.0/summary/4.5_day.geojson';
const PUBLISHER = 'USGS';

interface UsgsFeature {
  id: string;
  properties: { mag: number | null; title: string; time: number; url: string };
  geometry: { coordinates: [number, number, number?] } | null;
}

export async function usgsQuakes(fetcher: Fetcher): Promise<LiveRecord[]> {
  const doc = await getJson<{ features: UsgsFeature[] }>(fetcher, URL_4_5_DAY);
  const out: LiveRecord[] = [];

  for (const f of doc.features) {
    const at = f.geometry?.coordinates;
    if (!at || f.properties.mag === null) {
      continue;
    }
    out.push({
      id: `usgs:${f.id}`,
      kind: 'quake',
      title: f.properties.title,
      time: new Date(f.properties.time).toISOString(),
      lon: at[0],
      lat: at[1],
      url: f.properties.url,
      publisher: PUBLISHER,
      severity: f.properties.mag,
    });
  }
  return out;
}
